import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { Modal, ModalBody } from 'reactstrap';

const SchemeModel = ({ schemAvailed, show, onPublishClick, onCloseClick }) => {
  const [published, setPublished] = useState(false);

  useEffect(() => {
    if (published) {
      const timer = setTimeout(() => {
        onCloseClick();
        setPublished(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [published, onCloseClick]);

  return (
    <Modal size="sm" isOpen={show} toggle={onCloseClick} centered={true}>
      <div className="modal-content">
        <ModalBody className="px-4 py-5 text-center">
          <button
            type="button"
            onClick={onCloseClick}
            className="btn-close position-absolute end-0 top-0 m-3"
          ></button>
          <div className="avatar-sm mb-4 mx-auto">
            <div className={`avatar-title ${published ? 'bg-success' : 'bg-primary'} text-${published ? 'success' : 'primary'} bg-opacity-10 font-size-20 rounded-3`}>
              <i className={`mdi ${published ? 'mdi-check' : 'mdi-emoticon-happy-outline'}`}></i>
            </div>
          </div>


          <p className="text-muted font-size-16 mb-4">
            Congratulations! Scheme is availed for you
          </p>

          <div className="hstack gap-2 justify-content-center mb-0">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onCloseClick}
            >
              Close
            </button>
          </div>
        </ModalBody>
      </div>
    </Modal>

  );
};

SchemeModel.propTypes = {
  onCloseClick: PropTypes.func,
  onPublishClick: PropTypes.func,
  show: PropTypes.any,
  schemAvailed: PropTypes.string,
};

export default SchemeModel;
